module.exports = __webpack_public_path__ + "img/KLJK.87ccf9cc.png";